import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/suppliers'
import Component from 'components/Suppliers/Select'

export default createListModalContainer({ actions })(Component)
